export const DEBUGGER_PROPS = {
  show: 'all'
};
